import "./App.scss";
import "@fontsource/inter";
import Header from "./sections/Header";
import Main from "./sections/Main";

const App = () => {
	return (
		<>
			<Header />
			<Main />
		</>
	);
};

export default App;
